import { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import LoadingScreen from '../components/LoadingScreen';
import Hero from '../components/Hero';
import SelectedWorks from '../components/SelectedWorks';
import Journal from '../components/Journal';
import Explorations from '../components/Explorations';
import Stats from '../components/Stats';
import Footer from '../components/Footer';
import AboutSection from '../components/AboutSection';
import WhyManifesto from '../components/WhyManifesto';
import SolutionsBenefits from '../components/SolutionsBenefits';
import SystemProof from '../components/SystemProof';
import Testimonials from '../components/Testimonials';
import WhyNotAgency from '../components/WhyNotAgency';
import ProcessTimeline from '../components/ProcessTimeline';
import PricingSection from '../components/PricingSection';
import ContactFormBooking from '../components/ContactFormBooking';
import { useSeo } from '../lib/useSeo';

export default function HomePage() {
  const [isLoading, setIsLoading] = useState(true);

  useSeo({
    title: 'DAIEN - automatyzacje AI i aplikacje dla firm z Gdyni i Trójmiasta',
    description: 'DAIEN z Gdyni wdraża firmom z Gdańska, Gdyni, Sopotu i całego Trójmiasta automatyzacje AI, voiceboty 24/7 i aplikacje szyte na miarę. Mniej ręcznej roboty i zgubionych klientów, zdalnie także w całej Polsce.',
    path: '/',
  });

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      window.scrollTo(0, 0);
    }
    return () => { document.body.style.overflow = ''; };
  }, [isLoading]);

  return (
    <>
      <AnimatePresence>
        {isLoading && (
          <LoadingScreen onComplete={() => setIsLoading(false)} />
        )}
      </AnimatePresence>

      <main
        aria-hidden={isLoading}
        style={{
          visibility: isLoading ? 'hidden' : 'visible',
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 0.6s ease-out, visibility 0s',
        }}
      >
        <Hero />
        <SystemProof />
        <WhyManifesto />
        <SolutionsBenefits />
        <SelectedWorks />
        <Explorations />
        <ProcessTimeline />
        <AboutSection />
        <Testimonials />
        <WhyNotAgency />
        <Stats />
        <PricingSection />
        <Journal />
        <ContactFormBooking />
        <Footer />
      </main>
    </>
  );
}
